/**
 * @param {HTMLElement} el
 */
export const hideError = (el) => {
  const error = el.shadowRoot?.querySelector('.error')
  if (!error) {
    return
  }
  el.shadowRoot?.querySelectorAll('input, select').forEach((child) => {
    child.classList.remove('error')
  })
  error.textContent = ''
}
